/**
*
* Tag
*
*/

import React from 'react';
import PropTypes from 'prop-types';
import TagWrapper from 'commonStyles/TagWrapper';
import TagTextWrapper from './styles/TagTextWrapper';
import setCssMediaQuery from 'helpers/setCssMediaQuery';

function Tag(props) {

  const {
    tagWrapperThisStyles
  } = props;

  let templateStyling;

  if (props.commonProps) {

    const {
      customStyles
    } = props;

    const {
      styling,
      viewPort,
      frameRef
    } = props.commonProps;


    templateStyling = setCssMediaQuery(styling?.filterTagItem, props.typeOfStyle, viewPort, frameRef);
  }

  return (
    <TagWrapper {...props} $isActive={props.isActive} $thisStyles={tagWrapperThisStyles ? tagWrapperThisStyles : templateStyling} hasPointer={true}>
      <TagTextWrapper $innerColor={props.innerColor} $isActive={props.isActive} $innerColorActive={props.$innerColorActive} >{props.title}</TagTextWrapper>
    </TagWrapper>
  );
};

Tag.propTypes = {
  title: PropTypes.string,
  thisStyles: PropTypes.object,
  tagColor: PropTypes.string,
  hoverOff: PropTypes.bool,
  thisStyles: PropTypes.object,
  customHoverStyling: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object
  ]),
  isActive: PropTypes.bool,
  onClick: PropTypes.func
};

export default Tag;